import './SidebarFeature.less';
import useAppSelector from '../../hooks/useAppSelector';
import { useTranslation } from '../../hooks/useTranslation';
import ChatSidebarFeature from './chat/ChatSidebarFeature';
import Button from '../button/Button';
import useAppDispatch from '../../hooks/useAppDispatch';
import Icon from '../icon/Icon';

const SidebarFeature = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const sidebarFeatureItem = useAppSelector(
        state => state.featureState.sidebarFeatureItem
    );

    if (!sidebarFeatureItem) {
        return null;
    }
    const { chatType } = sidebarFeatureItem;

    return (
        <div
            className={`bri-SidebarFeature ${chatType !== 'general' ? 'bri-SidebarFeature-alternative' : ''}`}
        >
            <div className={`bri-SidebarFeature-header`}>
                <div
                    className={`bri-SidebarFeature-header-title bri-DisplayBoldFont`}
                >
                    <Icon iconId="brilliant-logo" />
                    {t(
                        chatType === 'general'
                            ? 'CHAT_TITLE_SEARCH_MODE'
                            : 'CHAT_TITLE_ANALYSIS_MODE'
                    )}
                </div>
                <Button
                    variant="text"
                    className={`bri-SidebarFeature-close-button`}
                    onClick={() =>
                        dispatch.featureState.setSidebarExpanded(false)
                    }
                >
                    {t('CLOSE')}
                </Button>
            </div>
            <div className={`bri-SidebarFeature-body`}>
                <ChatSidebarFeature />
            </div>
        </div>
    );
};

export default SidebarFeature;
